export const en: Record<string, string> = {

  "home.peopleHeading": "Find the right people for every job",

  // header
  "nav.explore": "Explore",
  "nav.howItWorks": "How It Works",
  "nav.pricing": "Pricing",
  "nav.blogs": "Blogs",
  "action.post": "Post",
  "nav.dashboard": "Go to Dashboard",
  "nav.adminDashboard": "Go to Admin Dashboard",
  "nav.accountSettings": "Account Settings",
  "nav.messages": "Messages",
  "nav.walletEscrow": "Wallet & Escrow",
  "nav.myPlan": "My Plan & Usage",
  // home hero
  "home.hero.findWork": "Find Work.",
  "home.hero.offerServices": "Offer Services.",
  "home.hero.hireTalent": "Hire Talent.",
  "home.hero.winContracts": "Win Contracts.",
  "home.hero.tagline": "The open Filipino marketplace for people, professionals, companies, jobs, services, projects, and contracts.",
  "home.hero.joinFree": "Join Free",
  "home.hero.joinFreeLong": "Join KontrataPH — Free",
  "home.hero.goDashboard": "Go to Dashboard",
  "home.hero.postJobProject": "Post a Job or Project",
  "home.search.button": "Search",
  "home.search.city": "City or Province",
  "home.search.servicePlaceholder": "What service do you need?",
  "home.findJobseekers": "Find Jobseekers",
  "home.findWork": "Find Work",
  "home.workforce.title": "Need 10, 50, or 500 workers?",
  "home.workforce.description": "Bulk hiring, developer procurement, and project portals for enterprises and LGUs.",
  "home.workforce.action": "Hire a Workforce",
  "home.finalCta.title": "Ready to get the job done?",
  "home.finalCta.description": "Post a job or project, or create your jobseeker profile — free to start.",
  "home.finalCta.postJob": "Post a Job",
  "home.finalCta.createProfile": "Create Jobseeker Profile",
  "home.trust.verified.title": "Verified Profiles",
  "home.trust.verified.description": "Real people. Real skills.",
  "home.trust.payments.title": "Secure Payments",
  "home.trust.payments.description": "Safe and hassle-free transactions.",
  "home.trust.contracts.title": "Clear Contracts",
  "home.trust.contracts.description": "Set expectations. Work with confidence.",
  "how.title": "How KontrataPH Works",
  "how.intro": "One trusted platform to hire, work, offer services, and win contracts — with verification, secure contracts, and escrow-protected payments.",
  "how.clients": "For Clients",
  "how.workers": "For Jobseekers",
  "how.client.step1": "Post your requirement",
  "how.client.desc1": "Post a job, service request, or project for bidding.",
  "how.client.step2": "Review verified applicants",
  "how.client.desc2": "Compare profiles, ratings, licenses, and bids.",
  "how.client.step3": "Agree on the contract",
  "how.client.desc3": "Set scope, milestones, and terms.",
  "how.client.step4": "Pay safely & review",
  "how.client.desc4": "Funds held in escrow, released on approval.",
  "how.worker.step1": "Create your profile",
  "how.worker.desc1": "Build a résumé or list your services.",
  "how.worker.step2": "Verify your identity",
  "how.worker.desc2": "Submit optional profession evidence for separate review. Your work reputation comes from reviews.",
  "how.worker.step3": "Apply or bid",
  "how.worker.desc3": "Apply for jobs or submit sealed bids.",
  "how.worker.step4": "Complete & get paid",
  "how.worker.desc4": "Deliver the work, get paid securely.",
  "how.trust": "Every deal is backed by verification, secure contracts, and escrow. Learn how to stay safe and what our badges mean.",
  "common.showLess": "Show less",
  "common.showMore": "Show more",
  "common.viewMore": "View more",
  "common.viewAll": "View all",
  "home.popularCategories": "Popular Categories",
  "home.viewAllCategories": "View all categories",
  "home.category.construction": "Construction & Trade",
  "home.category.professional": "Professional Services",
  "home.category.it": "IT & Digital Services",
  "home.category.business": "Business Services",
  "home.category.logistics": "Logistics & Transport",
  "home.category.home": "Home & Personal",
  "home.category.supplies": "Supplies & Equipment",
  "home.category.others": "Others",
  "home.category.serviceCount": "service",
  "home.category.servicesCount": "services",
  "home.featured": "Featured on KontrataPH",
  "home.viewAll": "View all",
  "home.recommended": "Recommended",
  "home.featuredListings": "Services, Jobs & Project Bidding",
  "home.featuredProfiles": "Jobseekers & Companies",
  "home.featuredLoading": "Loading featured listings…",
  "home.featuredEmpty": "No featured listings available right now",
  "home.featuredEmptyHint": "New marketplace listings will appear here as they are published.",
  // footer
  "footer.tagline": "The open Filipino marketplace for work, services, projects, and contracts.",
  "footer.col.jobSeekers": "For Job Seekers",
  "footer.col.professionals": "For Professionals",
  "footer.col.companies": "For Companies",
  "footer.col.about": "About KontrataPH",
  "footer.item.browseJobs": "Browse Jobs",
  "footer.item.postResume": "Post Résumé",
  "footer.item.howItWorks": "How It Works",
  "footer.item.careerResources": "Career Resources",
  "footer.item.browseServices": "Browse Services",
  "footer.item.listService": "List a Service",
  "footer.item.tipsGuides": "Tips & Guides",
  "footer.item.helpCenter": "Help Center",
  "footer.item.postJob": "Post a Job",
  "footer.item.companyProfiles": "Company Profiles",
  "footer.item.serviceRequests": "Service Requests",
  "footer.item.projectsBidding": "Projects & Bidding",
  "footer.item.aboutUs": "About Us",
  "footer.item.ourMission": "Our Mission",
  "footer.item.trustSafety": "Trust & Safety",
  "footer.item.terms": "Terms of Service",
  "footer.item.privacy": "Privacy Policy",
  // language
  "lang.label": "Language",
};

export const tl: Record<string, string> = {

  "home.peopleHeading": "Hanapin ang tamang tao para sa bawat trabaho",

  "nav.explore": "Tuklasin",
  "nav.howItWorks": "Paano Ito Gumagana",
  "nav.pricing": "Presyo",
  "nav.blogs": "Mga Blog",
  "action.post": "Mag-post",
  "nav.dashboard": "Pumunta sa Dashboard",
  "nav.adminDashboard": "Pumunta sa Admin Dashboard",
  "nav.accountSettings": "Mga Setting ng Account",
  "nav.messages": "Mga Mensahe",
  "nav.walletEscrow": "Wallet at Escrow",
  "nav.myPlan": "Aking Plano at Paggamit",
  "home.hero.findWork": "Maghanap ng Trabaho.",
  "home.hero.offerServices": "Mag-alok ng Serbisyo.",
  "home.hero.hireTalent": "Kumuha ng Manggagawa.",
  "home.hero.winContracts": "Manalo ng Kontrata.",
  "home.hero.tagline": "Ang bukas na Filipinong marketplace para sa mga tao, propesyonal, kompanya, trabaho, serbisyo, proyekto, at kontrata.",
  "home.hero.joinFree": "Sumali nang Libre",
  "home.hero.joinFreeLong": "Sumali sa KontrataPH — Libre",
  "home.hero.goDashboard": "Pumunta sa Dashboard",
  "home.hero.postJobProject": "Mag-post ng Trabaho o Proyekto",
  "home.search.button": "Maghanap",
  "home.search.city": "Lungsod o Probinsya",
  "home.search.servicePlaceholder": "Anong serbisyo ang kailangan mo?",
  "home.findJobseekers": "Find Jobseekers",
  "home.findWork": "Find Work",
  "home.workforce.title": "Kailangan ng 10, 50, o 500 manggagawa?",
  "home.workforce.description": "Maramihang pagkuha ng empleyado, pagkuha ng developer, at mga portal ng proyekto para sa mga negosyo at LGU.",
  "home.workforce.action": "Kumuha ng Maraming Manggagawa",
  "home.finalCta.title": "Handa ka na bang tapusin ang trabaho?",
  "home.finalCta.description": "Mag-post ng trabaho o proyekto, o gumawa ng profile bilang naghahanap ng trabaho — libre magsimula.",
  "home.finalCta.postJob": "Mag-post ng Trabaho",
  "home.finalCta.createProfile": "Gumawa ng Profile ng Naghahanap ng Trabaho",
  "home.trust.verified.title": "Mga Beripikadong Profile",
  "home.trust.verified.description": "Tunay na tao. Tunay na kasanayan.",
  "home.trust.payments.title": "Ligtas na mga Bayad",
  "home.trust.payments.description": "Ligtas at madaling transaksyon.",
  "home.trust.contracts.title": "Malinaw na mga Kontrata",
  "home.trust.contracts.description": "Magtakda ng malinaw na inaasahan. Magtrabaho nang may kumpiyansa.",
  "how.title": "Paano Gumagana ang KontrataPH",
  "how.intro": "Isang mapagkakatiwalaang platform para mag-hire, magtrabaho, mag-alok ng serbisyo, at manalo ng kontrata — may beripikasyon, ligtas na kontrata, at bayad na protektado ng escrow.",
  "how.clients": "Para sa mga Kliyente",
  "how.workers": "Para sa mga Naghahanap ng Trabaho",
  "how.client.step1": "I-post ang iyong kailangan",
  "how.client.desc1": "Mag-post ng trabaho, hiling na serbisyo, o proyektong maaaring pag-bid-an.",
  "how.client.step2": "Suriin ang mga beripikadong aplikante",
  "how.client.desc2": "Ihambing ang mga profile, rating, lisensya, at bid.",
  "how.client.step3": "Magkasundo sa kontrata",
  "how.client.desc3": "Itakda ang saklaw, mga yugto, at mga tuntunin.",
  "how.client.step4": "Magbayad nang ligtas at mag-review",
  "how.client.desc4": "Naka-escrow ang pondo at ilalabas kapag naaprubahan.",
  "how.worker.step1": "Gumawa ng iyong profile",
  "how.worker.desc1": "Gumawa ng résumé o ilista ang iyong mga serbisyo.",
  "how.worker.step2": "Beripikahin ang iyong pagkakakilanlan",
  "how.worker.desc2": "Magsumite ng opsyonal na patunay ng propesyon para sa hiwalay na pagsusuri. Galing sa mga review ang reputasyon mo sa trabaho.",
  "how.worker.step3": "Mag-apply o mag-bid",
  "how.worker.desc3": "Mag-apply sa mga trabaho o magsumite ng selyadong bid.",
  "how.worker.step4": "Tapusin ang trabaho at sumahod",
  "how.worker.desc4": "Ihatid ang trabaho at sumahod nang ligtas.",
  "how.trust": "May beripikasyon, ligtas na kontrata, at escrow na sumusuporta sa bawat kasunduan. Alamin kung paano manatiling ligtas at kung ano ang ibig sabihin ng aming mga badge.",
  "common.showLess": "Ipakita nang kaunti",
  "common.showMore": "Ipakita pa",
  "common.viewMore": "Tingnan pa",
  "common.viewAll": "Tingnan lahat",
  "home.popularCategories": "Mga Sikat na Kategorya",
  "home.viewAllCategories": "Tingnan ang lahat ng kategorya",
  "home.category.construction": "Konstruksyon at Kalakalan",
  "home.category.professional": "Mga Propesyonal na Serbisyo",
  "home.category.it": "Mga Serbisyong IT at Digital",
  "home.category.business": "Mga Serbisyong Pangnegosyo",
  "home.category.logistics": "Lohistika at Transportasyon",
  "home.category.home": "Mga Serbisyong Pantahanan at Personal",
  "home.category.supplies": "Mga Suplay at Kagamitan",
  "home.category.others": "Iba pa",
  "home.category.serviceCount": "serbisyo",
  "home.category.servicesCount": "serbisyo",
  "home.featured": "Tampok sa KontrataPH",
  "home.viewAll": "Tingnan lahat",
  "home.recommended": "Inirerekomenda",
  "home.featuredListings": "Mga Serbisyo, Trabaho at Pag-bid sa Proyekto",
  "home.featuredProfiles": "Mga Naghahanap ng Trabaho at Mga Kompanya",
  "home.featuredLoading": "Nilo-load ang mga tampok na listahan…",
  "home.featuredEmpty": "Wala pang tampok na listahan sa ngayon",
  "home.featuredEmptyHint": "Lalabas dito ang mga bagong listahan kapag na-publish na ang mga ito.",
  "footer.tagline": "Ang bukas na Filipinong marketplace para sa trabaho, serbisyo, proyekto, at kontrata.",
  "footer.col.jobSeekers": "Para sa Naghahanap ng Trabaho",
  "footer.col.professionals": "Para sa mga Propesyonal",
  "footer.col.companies": "Para sa mga Kompanya",
  "footer.col.about": "Tungkol sa KontrataPH",
  "footer.item.browseJobs": "Mag-browse ng Trabaho",
  "footer.item.postResume": "Mag-post ng Résumé",
  "footer.item.howItWorks": "Paano Ito Gumagana",
  "footer.item.careerResources": "Mga Career Resource",
  "footer.item.browseServices": "Mag-browse ng Serbisyo",
  "footer.item.listService": "Maglista ng Serbisyo",
  "footer.item.tipsGuides": "Mga Tip at Gabay",
  "footer.item.helpCenter": "Sentro ng Tulong",
  "footer.item.postJob": "Mag-post ng Trabaho",
  "footer.item.companyProfiles": "Mga Profile ng Kompanya",
  "footer.item.serviceRequests": "Mga Hiling na Serbisyo",
  "footer.item.projectsBidding": "Mga Proyekto at Bidding",
  "footer.item.aboutUs": "Tungkol sa Amin",
  "footer.item.ourMission": "Aming Misyon",
  "footer.item.trustSafety": "Tiwala at Kaligtasan",
  "footer.item.terms": "Mga Tuntunin ng Serbisyo",
  "footer.item.privacy": "Patakaran sa Privacy",
  "lang.label": "Wika",
};
